module.exports = __webpack_public_path__ + "static/img/Tangga DSK Versi 2.8c51df6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Tangga DSK Versi 2.jpg
// module id = 107
// module chunks = 1